import Carousel from 'react-material-ui-carousel';
import { Paper, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';

type ItemType = {
    src: string;
};

function CarouselComponent() {
    const items: ItemType[] = [
        { src: "/carousel-1.jpg" },
        { src: "/carousel-2.jpg" },
        { src: "/carousel-3.jpg" },
        { src: "/carousel-4.jpg" },
        { src: "/carousel-5.jpg" },
        { src: "/carousel-6.jpg" },
        { src: "/carousel-7.jpg" },
        { src: "/carousel-8.jpg" },
        { src: "/carousel-9.jpg" },
    ];

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    return (
        <Carousel
            // przyciski prawo-lewo

            // navButtonsAlwaysVisible
            // navButtonsProps={{
            //     style: {
            //         backgroundColor: "lightgray",
            //         color: "white",
            //         borderRadius: "50%",
            //         padding: "4px",
            //     }
            // }}
            
            indicatorContainerProps={{
                style: {
                    position: "absolute",
                    bottom: "10px",
                    zIndex: 2,
                    textAlign: "center",
                    width: "100%",
                }
            }}
            indicatorIconButtonProps={{
                style: {
                    color: "lightgray",
                }
            }}
            activeIndicatorIconButtonProps={{
                style: {
                    color: "lightpink",
                }
            }}
        >
            {items.map((item, i) => (
                <Item key={i} item={item} isMobile={isMobile} />
            ))}
        </Carousel>
    );
}

function Item({ item, isMobile }: { item: ItemType; isMobile: boolean }) {
    return (
        <Paper sx={{ position: 'relative' }}>
            <img
                src={item.src}
                alt="Carousel item"
                style={{
                    width: "90%",
                    height: isMobile ? "250px" : "650px",
                    objectFit: "cover",
                }}
            />
        </Paper>
    );
}

export default CarouselComponent;
